import type { BittsIcon } from '@crossbeam/bitts';

export type ModalSidebarItem<T> = {
  label: string;
  icon: BittsIcon;
  tab: T;
};

export function toSidebarTabs<T extends string>(items: ModalSidebarItem<T>[]) {
  return items.map((item) => ({
    name: item.label,
    value: item.tab,
    icon: item.icon,
  }));
}

export function findSidebarLabel<T extends string>(
  items: ModalSidebarItem<T>[],
  tab: T,
) {
  return items.find((item) => item.tab === tab)?.label ?? '';
}
